import React from "react";

const IntegrationReviewDetails = ({ details, onButtonClick }) => {

  if (!details) {
    return <div>Loading...</div>
  }

  const rowCls = "flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 py-1.5";
  const labelCls = "w-full sm:w-48 py-1 text-xs font-bold text-gray-700";
  const valueCls = "w-full max-w-5xl rounded-lg bg-white border border-blue-400 p-2.5 text-sm text-gray-900 shadow-sm";
  const badgeCls = `${valueCls} uppercase font-semibold text-blue-700 bg-blue-50/30`;

  return (
    <div className="w-full pt-2 pb-12">
      {/* Header */}
      <div className="mb-4">
        <div className="text-base font-bold text-gray-900 tracking-tight">Review Details</div>
        <div className="text-xs text-gray-600 mt-0.5">
          Here are the integration details. Click 'Save &amp; Deploy' to save the integration.
        </div>
      </div>

      {/* Details */}
      <div className="space-y-3">
        <div className={rowCls}>
          <div className={labelCls}>Integration Name:</div>
          <div className={valueCls}>{details.name}</div>
        </div>

        <div className={rowCls}>
          <div className={labelCls}>Description:</div>
          <div className={valueCls}>{details.description}</div>
        </div>

        <div className={rowCls}>
          <div className={labelCls}>Trigger:</div>
          <div className={badgeCls}>{details.triggerDetails?.triggerType}</div>
        </div>

        {details.triggerDetails &&
          (details.triggerDetails.triggerType === "Http Trigger" || details.triggerDetails.triggerType === "Webhook Trigger") && (
          <>
            <div className={rowCls}>
              <div className={labelCls}>Http Method:</div>
              <div className={`${valueCls} font-semibold`}>{details.triggerDetails.triggerHttpMethod}</div>
            </div>

            <div className={rowCls}>
              <div className={labelCls}>Trigger Request Schema:</div>
              <div className={valueCls}>
                <pre className="whitespace-pre-wrap break-words text-xs font-mono bg-gray-50/50 p-2 rounded-md">
                  {details.triggerDetails.triggerRequestSchema}
                </pre>
              </div>
            </div>

            <div className={rowCls}>
              <div className={labelCls}>Trigger Response Schema:</div>
              <div className={valueCls}>
                <pre className="whitespace-pre-wrap break-words text-xs font-mono bg-gray-50/50 p-2 rounded-md">
                  {details.triggerDetails.triggerResponseSchema}
                </pre>
              </div>
            </div>
          </>
        )}

        {details.sourceDetails?.sourceType === "REST API" && (
          <>
            <div className={rowCls}>
              <div className={labelCls}>Source Url:</div>
              <div className={`${valueCls} truncate`}>{details.sourceDetails.restAPISourceUrl}</div>
            </div>

            <div className={rowCls}>
              <div className={labelCls}>Source Type:</div>
              <div className={badgeCls}>{details.sourceDetails.sourceType}</div>
            </div>

            <div className={rowCls}>
              <div className={labelCls}>Source Http Method:</div>
              <div className={`${valueCls} font-semibold`}>{details.sourceDetails.restAPIHttpMethod}</div>
            </div>

            <div className={rowCls}>
              <div className={labelCls}>Source Request Schema:</div>
              <div className={valueCls}>
                <pre className="whitespace-pre-wrap break-words text-xs font-mono bg-gray-50/50 p-2 rounded-md">
                  {details.sourceDetails.restAPISourceRequestSchema}
                </pre>
              </div>
            </div>

            <div className={rowCls}>
              <div className={labelCls}>Source Response Schema:</div>
              <div className={valueCls}>
                <pre className="whitespace-pre-wrap break-words text-xs font-mono bg-gray-50/50 p-2 rounded-md">
                  {details.sourceDetails.restAPISourceResponseSchema}
                </pre>
              </div>
            </div>
          </>
        )}

        {details.destinationDetails?.destinationType === "REST API" && (
          <>
            <div className={rowCls}>
              <div className={labelCls}>Destination Type:</div>
              <div className={badgeCls}>{details.destinationDetails.destinationType}</div>
            </div>

            <div className={rowCls}>
              <div className={labelCls}>Destination Http Method:</div>
              <div className={`${valueCls} font-semibold`}>{details.destinationDetails.restAPIHttpMethod}</div>
            </div>

            <div className={rowCls}>
              <div className={labelCls}>Destination Request Schema:</div>
              <div className={valueCls}>
                <pre className="whitespace-pre-wrap break-words text-xs font-mono bg-gray-50/50 p-2 rounded-md">
                  {details.destinationDetails.restAPISourceRequestSchema}
                </pre>
              </div>
            </div>

            <div className={rowCls}>
              <div className={labelCls}>Destination Response Schema:</div>
              <div className={valueCls}>
                <pre className="whitespace-pre-wrap break-words text-xs font-mono bg-gray-50/50 p-2 rounded-md">
                  {details.destinationDetails.restAPISourceResponseSchema}
                </pre>
              </div>
            </div>
          </>
        )}

        {details.mappingDetails && (
          <div className={rowCls}>
            <div className={labelCls}>Data Mapping:</div>
            <div className={valueCls}>
              <pre className="whitespace-pre-wrap break-words text-xs font-mono bg-gray-50/50 p-2 rounded-md">
                {JSON.stringify(details.mappingDetails, null, 2)}
              </pre>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default IntegrationReviewDetails;
